/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { NamirasoftNWSMaxMindServer } from "./NamirasoftNWSMaxMindServer";

export class NamirasoftNWSMaxMindServerBase
{
    public server: NamirasoftNWSMaxMindServer;
    constructor(server: NamirasoftNWSMaxMindServer)
    {
        this.server = server;
    }
};